import * as React from 'react';

// @ts-expect-error
import {Body, BodyProps} from '../typography/body';

import styles from './error-message.module.css';

type Props = {
    as: string;
    children: React.ReactNode;
} & BodyProps;

ErrorMessage.defaultProps = {
    as: 'div',
};

export function ErrorMessage(props: Props) {
    const {as: Tag, children, ...bodyProps} = props;

    return (
        <Tag className={styles.error}>
            <Body {...bodyProps}>{children}</Body>
        </Tag>
    );
}
